import { http } from 'services/http';
import { INVOICES_GET_MANY, INVOICES_GET_ONE } from 'api/query-keys.ts';
import type { InvoiceRes, TUpdateInvoicePartiallyPaidAmountReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useUpdateInvoicePartiallyPaidAmount = (invoiceId: number) => {
  return useMutationBase<InvoiceRes, unknown, TUpdateInvoicePartiallyPaidAmountReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<InvoiceRes>(`/v1/invoices/${invoiceId}/partially-paid-amount`, variables);

      return res.data;
    },

    invalidateCallback: ({ id }) => [[INVOICES_GET_ONE, id], [INVOICES_GET_MANY]],
  });
};
